export default "__VITE_ASSET__8a0d0f37__"